// extracted by mini-css-extract-plugin
export default {"root":"CategoryToggle_root__2UDiV","tab":"CategoryToggle_tab__ql0hk","tabActive":"CategoryToggle_tabActive__xFAgh"};